/* Licks — motion helpers (reveal on scroll, counters). No dependencies. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight) * 1.05;
  }
  function show(el) { el.classList.add('is-in'); if (io) io.unobserve(el); }
  function observer() {
    if (io || reduce || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting || en.intersectionRatio > 0) show(en.target); });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.01 });
    return io;
  }
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lk-reveal:not(.is-in)');
    if (!els.length) return;
    var ob = observer();
    els.forEach(function (e) {
      if (reduce || !ob || inViewport(e)) { show(e); return; }
      ob.observe(e);
    });
    // Safety net: whatever happens, nothing stays invisible for long.
    setTimeout(function () {
      (root || document).querySelectorAll('.lk-reveal:not(.is-in)').forEach(function (e) { if (inViewport(e)) show(e); });
    }, 600);
    setTimeout(function () {
      (root || document).querySelectorAll('.lk-reveal:not(.is-in)').forEach(show);
    }, 4000);
  }
  function initCounters(root) {
    (root || document).querySelectorAll('[data-lk-count]').forEach(function (el) {
      if (el.dataset.lkDone) return;
      var target = parseFloat(el.dataset.lkCount), dur = 1200, start = null, suffix = el.dataset.lkSuffix || '';
      if (isNaN(target)) return;
      el.dataset.lkDone = '1';
      function run() {
        if (reduce) { el.textContent = target + suffix; return; }
        function step(ts) { if (!start) start = ts; var p = Math.min((ts - start) / dur, 1); var v = Math.round(target * (1 - Math.pow(1 - p, 3))); el.textContent = v + suffix; if (p < 1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      }
      if (!('IntersectionObserver' in window) || inViewport(el)) { run(); return; }
      var cio = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) { cio.disconnect(); run(); } }, { threshold: 0.3 });
      cio.observe(el);
    });
  }
  function init(root) { initReveal(root); initCounters(root); }
  var scheduled = false;
  function schedule(root) { if (scheduled) return; scheduled = true; requestAnimationFrame(function () { scheduled = false; init(root); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  window.addEventListener('load', function () { init(); });
  window.addEventListener('pageshow', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('page:loaded', function () { init(); });
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); break; } }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  window.LicksMotion = { init: init };
})();

/* Scorrimento automatico lento per scroller orizzontali: [data-lk-autoscroll="px/s"] */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setup(track) {
    if (track.dataset.lkAsReady) return; track.dataset.lkAsReady = '1';
    var speed = parseFloat(track.dataset.lkAutoscroll) || 24;
    var kids = Array.prototype.slice.call(track.children);
    if (kids.length < 2) return;
    // clona per un loop continuo
    kids.forEach(function (k) { var c = k.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.classList.add('is-in'); c.classList.remove('lk-reveal'); c.removeAttribute('data-shopify-editor-block'); c.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); }); track.appendChild(c); });
    var half = 0, paused = false, resumeT = null, last = null, acc = 0;
    function measure() { half = 0; for (var i = 0; i < kids.length; i++) half += kids[i].getBoundingClientRect().width; var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0; half += gap * kids.length; }
    measure(); window.addEventListener('resize', measure);
    function pause() { paused = true; clearTimeout(resumeT); }
    function resume(delay) { clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; last = null; }, delay || 2500); }
    track.addEventListener('mouseenter', pause); track.addEventListener('mouseleave', function () { resume(600); });
    track.addEventListener('pointerdown', pause); track.addEventListener('pointerup', function () { resume(3000); });
    track.addEventListener('touchstart', pause, { passive: true }); track.addEventListener('touchend', function () { resume(3000); }, { passive: true });
    track.addEventListener('focusin', pause); track.addEventListener('focusout', function () { resume(1500); });
    track.addEventListener('wheel', function () { pause(); resume(3000); }, { passive: true });
    var section = track.closest('section, .lk-section') || track;
    section.querySelectorAll('[data-lk-prev],[data-lk-next]').forEach(function (b) { b.addEventListener('click', function () { pause(); resume(4000); }); });
    var visible = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.05 }).observe(track);
    if (reduce) return;
    track.style.scrollSnapType = 'none';
    var scrolling = 0;
    window.addEventListener('scroll', function () { scrolling = performance.now(); }, { passive: true });
    function tick(now) {
      if (!track.isConnected) return;
      if (!paused && visible && half > 0 && now - scrolling > 250) {
        if (last != null) { acc += (now - last) / 1000 * speed; var px = Math.floor(acc); if (px >= 1) { acc -= px; track.scrollLeft += px; } }
        if (track.scrollLeft >= half) track.scrollLeft -= half;
      }
      last = now; requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  var lazyIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) { lazyIO.unobserve(e.target); setup(e.target); } }); }, { rootMargin: '400px 0px' }) : null;
  function init(root) { (root || document).querySelectorAll('[data-lk-autoscroll]').forEach(function (t) { if (lazyIO) lazyIO.observe(t); else setup(t); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.LicksAutoScroll = { init: init };
})();

/* Video finiture: partono solo quando visibili, si fermano fuori schermo */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { var v = e.target; v.dataset.lkVis = e.isIntersecting ? '1' : ''; if (e.isIntersecting) tryPlay(v); else v.pause(); });
  }, { rootMargin: '120px 0px', threshold: 0.01 });
  function tryPlay(v) {
    if (!v.paused || v.dataset.lkNoAuto) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {
      if (v.dataset.lkRetried) { v.dataset.lkNoAuto = '1'; return; }
      v.dataset.lkRetried = '1';
      v.addEventListener('canplay', function () { if (v.dataset.lkVis) { var q = v.play(); if (q && q.catch) q.catch(function () { v.dataset.lkNoAuto = '1'; }); } }, { once: true });
      if (v.readyState === 0) { try { v.load(); } catch (e) {} }
    });
  }
  function init(root) { (root || document).querySelectorAll('video[data-lk-finvid]').forEach(function (v) { if (v.dataset.lkIo) return; v.dataset.lkIo = '1'; io.observe(v); }); }
  setInterval(function () { document.querySelectorAll('video[data-lk-finvid][data-lk-vis="1"]').forEach(function (v) { if (v.paused && !document.hidden) tryPlay(v); }); }, 1500);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  new MutationObserver(function () { init(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* lk-scroll-top-fix: una nuova pagina aperta da un link parte sempre dall'inizio (non riguarda indietro/avanti né gli anchor #) */
(function () {
  var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  var type = nav ? nav.type : 'navigate';
  if (type !== 'navigate' || location.hash) return;
  var touched = false;
  ['wheel', 'touchmove', 'keydown', 'scroll'].forEach(function (e) { window.addEventListener(e, function () { if (e !== 'scroll' || performance.now() > 1500) touched = true; }, { passive: true, once: true }); });
  function toTop() { if (!touched && !location.hash && window.pageYOffset > 0) window.scrollTo(0, 0); }
  toTop();
  window.addEventListener('pagereveal', toTop);
  document.addEventListener('DOMContentLoaded', toTop);
  window.addEventListener('load', function () { toTop(); setTimeout(toTop, 50); });
})();

/* lk-menu-img-defer: le immagini dei menu a tendina si caricano solo alla prima apertura */
(function () {
  var done = false;
  function load() {
    if (done) return; done = true;
    document.querySelectorAll('img[data-lk-src]').forEach(function (img) {
      if (img.dataset.lkSrcset) img.srcset = img.dataset.lkSrcset;
      img.src = img.dataset.lkSrc; img.removeAttribute('data-lk-src'); img.removeAttribute('data-lk-srcset');
    });
  }
  function arm() {
    var hdr = document.querySelector('header, .header-section, #header-component') || document.body;
    ['pointerenter', 'pointerdown', 'focusin', 'touchstart', 'mouseover'].forEach(function (e) { hdr.addEventListener(e, load, { passive: true, once: true }); });
    document.querySelectorAll('[data-lk-mm], .menu-drawer, header-drawer, .header__drawer').forEach(function (el) { el.addEventListener('pointerdown', load, { passive: true, once: true }); });
    /* lk-menu-img-prewarm: il solo hover sull'header arrivava troppo tardi — il menu si apriva mentre
       le immagini stavano ancora scaricando. Al primo segno di vita (mouse, scroll, tastiera) le
       scarichiamo in anticipo, e comunque entro ~1,5s di inattivita'. */
    ['mousemove', 'scroll', 'keydown', 'wheel'].forEach(function (e) { document.addEventListener(e, load, { passive: true, once: true }); });
    /* lk-menu-img-now: le immagini del menu ora pesano ~110 KB in tutto (erano 1,1 MB), quindi
       non vale piu' la pena rimandarle: partono appena la pagina e' pronta, a priorita' bassa.
       I listener qui sopra restano come rete di sicurezza. */
    setTimeout(load, 0);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
})();

/* ===== Combo con ricerca per liste lunghe (caschi) ===== */
(function () {
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function setup(root) {
    var input = root.querySelector('[data-lk-combo-input]'),
        list = root.querySelector('[data-lk-combo-list]'),
        hidden = root.querySelector('[data-lk-combo-value]'),
        none = root.querySelector('[data-lk-combo-none]'),
        toggle = root.querySelector('[data-lk-combo-toggle]'),
        data = root.querySelector('[data-lk-combo-data]');
    if (!input || !list || !hidden || root.dataset.lkComboReady) return;
    root.dataset.lkComboReady = '1';
    var items = [];
    try { items = JSON.parse(data.textContent) || []; } catch (e) { items = []; }
    var active = -1, open = false;
    /* strict: adventure/scooter, si sceglie SOLO dall'elenco (niente testo libero) */
    var strict = root.hasAttribute('data-lk-combo-strict');
    function exact(q) {
      var nq = norm(q).trim();
      if (!nq) return '';
      for (var i = 0; i < items.length; i++) if (norm(items[i]).trim() === nq) return items[i];
      return '';
    }

    function render(q) {
      var nq = norm(q).trim();
      var hits = nq ? items.filter(function (it) { return norm(it).indexOf(nq) > -1; }) : items.slice();
      list.innerHTML = '';
      hits.slice(0, 200).forEach(function (it, i) {
        var li = document.createElement('li');
        li.className = 'lk-combo__opt';
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', String(it === hidden.value));
        li.dataset.value = it;
        if (nq) {
          var p = norm(it).indexOf(nq);
          li.appendChild(document.createTextNode(it.slice(0, p)));
          var m = document.createElement('mark'); m.textContent = it.slice(p, p + nq.length);
          li.appendChild(m);
          li.appendChild(document.createTextNode(it.slice(p + nq.length)));
        } else { li.textContent = it; }
        li.addEventListener('mousedown', function (e) { e.preventDefault(); choose(it); });
        list.appendChild(li);
      });
      active = -1;
      if (none && !strict) none.hidden = !(nq && hits.length === 0);
      else if (none && nq && hits.length) none.hidden = true;
      return hits.length;
    }
    function show(q) { render(q); list.hidden = false; open = true; root.classList.add('is-open'); input.setAttribute('aria-expanded', 'true'); }
    function hide() { list.hidden = true; open = false; root.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); }
    function choose(v) { input.value = v; hidden.value = v; if (none) none.hidden = true; hide(); input.dispatchEvent(new Event('change', { bubbles: true })); }
    function move(d) {
      var opts = list.querySelectorAll('.lk-combo__opt');
      if (!opts.length) return;
      active = (active + d + opts.length) % opts.length;
      opts.forEach(function (o, i) { o.classList.toggle('is-active', i === active); });
      opts[active].scrollIntoView({ block: 'nearest' });
    }

    input.addEventListener('input', function () {
      hidden.value = strict ? exact(input.value) : input.value.trim();
      show(input.value);
    });
    input.addEventListener('focus', function () { show(input.value); });
    input.addEventListener('blur', function () {
      setTimeout(function () {
        hide();
        /* in strict, quello che non e' in elenco non resta scritto: si svuota e si avvisa */
        if (strict && input.value.trim() && !hidden.value) {
          input.value = '';
          if (none) none.hidden = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 120);
    });
    if (toggle) toggle.addEventListener('click', function () { if (open) { hide(); } else { input.focus(); show(''); } });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (!open) show(input.value); else move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Enter') {
        var opts = list.querySelectorAll('.lk-combo__opt');
        if (open && active > -1 && opts[active]) { e.preventDefault(); choose(opts[active].dataset.value); }
        else hide();
      } else if (e.key === 'Escape') { hide(); }
    });
  }
  function init(scope) { (scope || document).querySelectorAll('[data-lk-combo]').forEach(setup); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ── Conteggio dei clic sul bottone WhatsApp ────────────────────────────────
   Perche' serve: il sito spinge WhatsApp ovunque e la vendita si chiude li'.
   Senza questo evento il passaggio ads → WhatsApp e' invisibile: a Meta
   arrivano solo gli ordini digitati a mano, che partono dal server e senza
   id del clic, quindi non dicono da dove viene il cliente.
   Questo evento invece nasce nel BROWSER, nel momento vero, e porta con se'
   il cookie del clic sull'inserzione: e' l'unico modo per legare una
   conversazione WhatsApp a un reel.

   Un solo ascoltatore delegato copre TUTTI i link wa.me — le 9 sezioni che
   ce l'hanno piu' il bottone flottante — e anche quelli aggiunti in futuro.
   `Contact` e' un evento STANDARD di Meta: si puo' usare per ottimizzare una
   campagna, una custom no. */
(function () {
  var ultimoClic = 0;
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var link = t.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]');
    if (!link) return;

    var ora = Date.now();
    if (ora - ultimoClic < 1200) return;   // stesso bottone premuto due volte
    ultimoClic = ora;

    // da quale sezione del sito e' partito: serve a capire cosa spinge a scrivere.
    // Uso l'id di sezione Shopify (c'e' sempre) invece delle classi CSS: su 4 bottoni
    // su 4 funziona, mentre cercando una classe "licks-" ne beccavo solo 1.
    // "shopify-section-template--32092114878802__licks_faq" -> "licks_faq"
    var dove = 'altro';
    var sez = link.closest('.shopify-section');
    if (sez && sez.id) {
      var pezzi = sez.id.split('__');
      dove = pezzi[pezzi.length - 1] || sez.id;
    } else if (link.closest('footer')) {
      dove = 'footer';
    }

    // quale pulsante: data-lk-wa se il link lo dichiara (pulsanti nuovi del configuratore), altrimenti si deduce
    var tipo = link.getAttribute('data-lk-wa');
    if (!tipo) {
      if (link.classList.contains('lk-wa-float')) tipo = 'flottante';
      else if (link.closest('.lkw-bubble')) tipo = 'fumetto';
      else tipo = 'sezione-' + dove;
    }

    var main = document.querySelector('main');
    try {
      if (typeof fbq === 'function') {
        fbq('track', 'Contact', {
          content_name: dove,
          content_category: (main && main.dataset && main.dataset.template) || 'sconosciuto',
          content_ids: [location.pathname],
          // 31/10: pagina e tipo di pulsante come parametri propri (content_ids non si legge bene in Events Manager)
          pagina: location.pathname,
          pulsante: tipo,
          // stesso codice che finisce nel messaggio WhatsApp: cosi' il clic
          // registrato qui e il messaggio che arriva a Licks si richiamano
          content_type: (typeof window.lkRifWhatsApp === 'function' && window.lkRifWhatsApp()) || 'organico'
        });
      }
    } catch (err) { /* il tracciamento non deve mai rompere il bottone */ }

    // stessa informazione in Clarity (tag di sessione): filtro «sessioni che hanno premuto WhatsApp» per pagina/pulsante
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'wa_pagina', location.pathname);
        window.clarity('set', 'wa_pulsante', tipo);
      }
    } catch (err) { /* idem */ }
  }, true);
})();

/* ── Da quale inserzione arriva chi preme WhatsApp ──────────────────────────
   A COSA SERVE: l'evento `Contact` qui sopra dice che qualcuno ha premuto il
   bottone, ma non da dove arrivava. Qui si ricavano le UTM dell'atterraggio e
   si tengono per tutta la visita, cosi' il `Contact` porta con se' la reel.

   ⛔ NON si tocca il messaggio precompilato di WhatsApp. C'era una versione che
   ci infilava un "(rif. IG-32)" da far ricopiare sull'ordine: tolta il 23/09 su
   richiesta di Lorenzo, perche' Licks teme che un codice tra parentesi insospettisca
   chi scrive. Il cliente non deve vedere niente di tutto questo.
   → Conseguenza da tenere presente: sappiamo che il bottone e' stato premuto e da
   quale reel veniva quella persona, ma NON che quella stessa persona ha comprato.
   L'ordine lo digita Licks a mano e non c'e' niente che li ricolleghi.

   sessionStorage e non localStorage: una visita nuova deve poter essere
   attribuita a un'inserzione diversa. */
(function () {
  var CHIAVE = 'lk_rif';

  /* "32 — REEL quando la parcheggi si girano (9:16) — rotazione" -> "32"
     I nomi delle ads iniziano tutti con due cifre. Se un domani non iniziassero
     per numero, si ripiega sulle prime lettere ripulite. */
  function siglaAd(nome) {
    if (!nome) return '';
    var n = String(nome).trim();
    var m = n.match(/^\s*(\d{1,3})\b/);
    if (m) return m[1];
    return n.replace(/[^A-Za-z0-9]+/g, '').slice(0, 10).toUpperCase();
  }

  function calcolaRif() {
    try {
      var p = new URLSearchParams(location.search);
      var src = (p.get('utm_source') || '').trim().toUpperCase();
      var ad = siglaAd(p.get('utm_content'));
      if (src && ad) return src + '-' + ad;
      if (ad) return ad;
      if (src) return src;
      // Nessuna UTM ma c'e' l'id del clic Meta: le UTM possono essere state
      // tolte per strada, ma che venga da un'inserzione lo sappiamo lo stesso.
      if (p.get('fbclid')) return 'ADS';
      return '';
    } catch (err) { return ''; }
  }

  function rif() {
    try {
      var nuovo = calcolaRif();
      if (nuovo) sessionStorage.setItem(CHIAVE, nuovo);
      return nuovo || sessionStorage.getItem(CHIAVE) || '';
    } catch (err) {
      // finestra anonima, memoria bloccata: si usa solo quello che c'e' nell'url
      return calcolaRif();
    }
  }

  // si fissa gia' all'atterraggio, cosi' sopravvive alla navigazione interna
  rif();

  // letto dall'evento Contact qui sopra
  window.lkRifWhatsApp = rif;
})();

/* ── Consenso a Clarity ─────────────────────────────────────────────────────
   IL PROBLEMA: Clarity partiva in modalita' "aspetto il consenso". Senza quel
   segnale non scrive i suoi cookie, e senza cookie non riesce a collegare due
   pagine della stessa persona: ogni pagina diventava una sessione nuova.
   Si vedeva nei dati — 1,02 pagine per sessione su OGNI browser, Chrome da
   scrivania compreso, e piu' "utenti distinti" (2.658) che sessioni (2.399),
   che è impossibile se l'identita' reggesse.
   Verificato il 23/09 chiamando clarity('consent') dalla console sul sito
   live: `_clck` e `_clsk` sono comparsi subito.

   ⚠️ NOTA NON TECNICA: questo allinea Clarity a come il sito gia' si comporta
   con il pixel Meta, che scrive `_fbp` senza chiedere niente perche' il banner
   cookie e' stato tolto apposta. Non cambia la posizione del sito, la applica
   anche a Clarity. Se un domani si rimette un banner, il consenso va spostato
   dentro la callback del banner e questa riga va tolta.

   Il frammento di Clarity in theme.liquid definisce window.clarity subito come
   funzione che accoda, quindi chiamarla qui funziona anche se la libreria vera
   non e' ancora scesa. I tentativi ripetuti coprono il caso in cui questo file
   giri prima del frammento. */
(function () {
  var tentativi = 0;
  function acconsenti() {
    try {
      if (typeof window.clarity === 'function') { window.clarity('consent'); return true; }
    } catch (err) { /* mai rompere la pagina per un consenso mancato */ }
    return false;
  }
  if (acconsenti()) return;
  var t = setInterval(function () {
    if (acconsenti() || ++tentativi > 20) clearInterval(t);   // max ~5 secondi
  }, 250);
})();
